// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyCertificateFilledSvg from "@fishx/icons-svg/es/asn/SafetyCertificateFilled";
import FishxIcon from '../components/FishxIcon';

var SafetyCertificateFilled = function SafetyCertificateFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateFilledSvg
  }));
};

SafetyCertificateFilled.displayName = 'SafetyCertificateFilled';
export default React.forwardRef(SafetyCertificateFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SafetyCertificateFilled.js
// module id = 4045
// module chunks = 0